// extracted by mini-css-extract-plugin
export var actions = "_3s-0";
export var actionsContainer = "_3s-6";
export var border = "_3s-1";
export var childFullHeight = "_3s-d";
export var collapse = "_3s-2";
export var content = "_3s-8";
export var contentChild = "_3s-c";
export var fullscreen = "_3s-a";
export var headerContainer = "_3s-3";
export var headerRow = "_3s-5";
export var hidePadding = "_3s-9";
export var noScrollX = "_3s-e";
export var noScrollY = "_3s-f";
export var optOutTopPadding = "_3s-b";
export var pagePadding = "_3s-7";
export var profile = "_3s-g";
export var profileContainer = "_3s-h";
export var profileImage = "_3s-i";
export var profileMain = "_3s-j";
export var profileSubtitle = "_3s-l";
export var profileTitle = "_3s-k";
export var tabsWrapper = "_3s-4";
export var title = "_3s-m";